export * from './auth.service';
export * from './calendar.service';
export * from './classi.service';
export * from './minor.service';
export * from './minori.service';
export * from './familiari.service';
export * from './communication.service';
